// AI Generated Test
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'table-select-item',
    standalone: false,
    template: `<input
        [attr.aria-label]="monLabel"
        [disabled]="disable"
        [checked]="hasItem()"
        (click)="toggleItem()"
        type="checkbox"
    />`,
})
export class TableSelectItemComponent implements OnInit {
    @Input() item: any;
    @Input() selectedItems: any[] = [];
    @Input() monLabel?: string;
    @Input() disable?: boolean = false;
    @Output() selectedItemsChange = new EventEmitter<any[]>();

    constructor (private translateService: TranslateService) {}

    ngOnInit (): void {
        this.monLabel = this.monLabel || this.translateService.getString('Select item');
        this.selectedItems = this.selectedItems || [];
        this.disable = this.disable || false;
    }

    hasItem (): boolean {
        return this.indexOfItem() > -1;
    }

    toggleItem (): void {
        const index = this.indexOfItem();
        if (index === -1) {
            this.selectedItems.push(this.item);
        } else {
            this.selectedItems.splice(index, 1);
        }
        this.selectedItemsChange.emit(this.selectedItems);
    }

    private indexOfItem (): number {
        const stringified = this.stringify(this.item);
        for (let i = 0; i < this.selectedItems.length; i++) {
            if (this.stringify(this.selectedItems[i]) === stringified) {
                return i;
            }
        }
        return -1;
    }

    private stringify (val: any): string {
        return JSON.stringify(val, (key, value) => {
            let returnVal = value;

            if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
                returnVal = undefined;
            }

            return returnVal;
        });
    }
}
